/* eslint-disable import/order */
import { customerServiceCustomerDetailsEntryPoint } from '@jira/spa-apps__customer-service-customer-details/src/customerServiceCustomerDetailsEntryPoint.entrypoint.tsx';
import { l1CustomersProjectProviderResource } from '@jira/router-resources__customer-service-l1-customers-project-provider/src/l1CustomersProjectProviderResource.tsx';
import { CustomerDetailsPageQueryResource } from '@jira/router-resources__service-desk-customer-service-customer-details/src/CustomerDetailsPageQueryResource.tsx';
import { EntitlementsQueryResource } from '@jira/router-resources__service-desk-customer-service-customer-details/src/EntitlementsQueryResource.tsx';
import ErrorPagesNotFound from '@jira/router-routes__common/src/ui/error-pages/not-found/index.tsx';
import { customerServiceCustomerDetailsRoute } from '@jira/router-routes__customer-services-customers-routes/src/customerServiceCustomerDetailsRoute.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { globalLayout } from '@jira/platform__layouts-global-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

const customerServiceCustomerDetailsPageEntryPoint = createPageEntryPoint({
	main: customerServiceCustomerDetailsEntryPoint,
});

export const customerServiceCustomerDetailsRouteEntry: Route = createEntry(
	customerServiceCustomerDetailsRoute,
	() => ({
		group: 'customer-service',
		perfMetricKey: 'customer-service.customer-details',
		layout: globalLayout,

		// eslint-disable-next-line no-restricted-syntax
		component: ErrorPagesNotFound,

		entryPoint() {
			return fg('berry-6285-customers-l1')
				? customerServiceCustomerDetailsPageEntryPoint
				: undefined;
		},

		resources: [
			...getNavigationResources(),
			CustomerDetailsPageQueryResource,
			EntitlementsQueryResource,
			l1CustomersProjectProviderResource,
		],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
